import events from './events'
import store from 'reducers'
import Actions from './Actions'

export default class LoadingActions extends Actions{
    static get target(){
        return 'loading'
    }

    static append(data){
        store.dispatch({
            type: 'set',
            target: this.target,
            payload: {
                ...store.getState().loading,
                ...data
            }
        })
    }
}


// WEBPACK FOOTER //
// ./actions/LoadingActions.js